import React, { useState } from 'react'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import Filterbar from '../Filterbar'
import DayTimeline from './DayTimeline'
import { Canvas } from '../styles'
import {
  roundStartHour,
  roundEndHour,
  DEFAULT_START,
  DEFAULT_END,
} from './hooks/usePeriodOfTime'
import { useLoadData } from './hooks/useLoadData'
import { nowOnClinicTimezone } from '@/v2/utils/convert'
import useDetectDevice from '@/v2/hooks/useDetectDevice'

const today = format(nowOnClinicTimezone(), 'yyyy-MM-dd')

const Daily = () => {
  const { date = today } = useParams()
  const { isMobile } = useDetectDevice()
  const [subjectView, setSubjectView] = useState('room')
  const [typeFilter, setTypeFilter] = useState([])
  const [selectedColumn, setSelectedColumn] = useState(null) // For mobile: specific room/doctor filter

  const {
    loading,
    error,
    appointments,
    timeOffs,
    clinicHours,
    startHour,
    endHour,
  } = useLoadData(date)

  const defaultStartHour =
    startHour != null
      ? roundStartHour(Math.min(startHour, DEFAULT_START))
      : DEFAULT_START
  const defaultEndHour =
    endHour != null ? roundEndHour(Math.max(endHour, DEFAULT_END)) : DEFAULT_END

  // Update subject view (column reset is handled by Filterbar when needed)
  const handleSubjectChange = newSubject => {
    setSubjectView(newSubject)
  }

  return (
    <Canvas>
      <Filterbar
        onChangeSubject={handleSubjectChange}
        onChangeType={setTypeFilter}
        subjectView={subjectView}
        selectedColumn={selectedColumn}
        onChangeColumn={setSelectedColumn}
      />
      <DayTimeline
        date={date}
        subjectView={subjectView}
        typeFilter={typeFilter}
        selectedColumn={selectedColumn}
        isMobile={isMobile}
        loading={loading}
        error={error}
        appointments={appointments}
        timeOffs={timeOffs}
        clinicHours={clinicHours}
        defaultStartHour={defaultStartHour}
        defaultEndHour={defaultEndHour}
      />
    </Canvas>
  )
}

export default Daily
